import PropTypes from 'prop-types';
import InnerFormSection from 'components/ui-components/forms/InnerFormSection';
import HookFormPostcodeSelector from 'components/cef_form/hook-form/HookFormPostcodeSelector';
import HookFormRadioContainer from 'components/cef_form/hook-form/HookFormRadioContainer';
import validateNullRadio from 'utils/hook-form/validateNullRadio';

const HomeAddressSelector = ({
  postcodeSearched,
  setPostcodeSearched,
  setPostcodeIsReset,
  addressDataModel,
  persistedData,
}) => {
  const ownPropertyRadioItems = [
    {
      id: 'ownPropertyYes',
      label: 'Yes',
      value: true,
    },
    {
      id: 'ownPropertyNo',
      label: 'No',
      value: false,
    },
  ];

  const propertyDurationRadioItems = [
    {
      id: 'propertyDurationYes',
      label: 'Yes',
      value: true,
    },
    {
      id: 'propertyDurationNo',
      label: 'No',
      value: false,
    },
  ];

  return (
    <InnerFormSection title="Home Address">
      <HookFormPostcodeSelector
        className="mt-20"
        id="home"
        postcodeSearched={postcodeSearched}
        setPostcodeSearched={setPostcodeSearched}
        setPostcodeIsReset={setPostcodeIsReset}
        addressDataModel={addressDataModel}
        persistedData={persistedData}
      />

      {postcodeSearched && (
        <>
          <div className="mt-20">
            <HookFormRadioContainer
              direction="horizontal"
              id="addresses.1.own"
              label="Do you own this property?"
              radioItems={ownPropertyRadioItems}
              rules={{
                validate: validateNullRadio,
              }}
            />
          </div>

          <div className="mt-20">
            <HookFormRadioContainer
              direction="horizontal"
              id="addresses.1.more_than_3_years"
              label="Have you been at this property more than 3 years?"
              radioItems={propertyDurationRadioItems}
              rules={{
                validate: validateNullRadio,
              }}
            />
          </div>
        </>
      )}
    </InnerFormSection>
  );
};

HomeAddressSelector.propTypes = {
  postcodeSearched: PropTypes.bool.isRequired,
  setPostcodeSearched: PropTypes.func,
  addressDataModel: PropTypes.shape({
    'addresses.1.house_number': PropTypes.string,
    'addresses.1.address_line_1': PropTypes.string,
    'addresses.1.address_line_2': PropTypes.string,
    'addresses.1.address_line_3': PropTypes.string,
    'addresses.1.address_line_4': PropTypes.string,
    'addresses.1.postcode': PropTypes.string,
  }),
  persistedData: PropTypes.shape({
    house_number: PropTypes.string,
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    address_line_3: PropTypes.string,
    address_line_4: PropTypes.string,
    postcode: PropTypes.string,
  }),
};

export default HomeAddressSelector;
